import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=88f0270a&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=88f0270a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f0270a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88f0270a')) {
      api.createRecord('88f0270a', component.options)
    } else {
      api.reload('88f0270a', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=88f0270a&scoped=true&", function () {
      api.rerender('88f0270a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/publishGoods/components/BaseInfo.vue"
export default component.exports